module.exports = __webpack_public_path__ + "static/media/test1_4.d4a162b7.png";